import React from 'react';
import PropTypes from 'prop-types';

import './Divider.scss';

const Divider = (props) => {
  const { marginHorizontal, marginVertical } = props;
  let dividerWidthStyle;

  if (marginHorizontal > 0) {
    const dividerMargin = marginHorizontal * 2;
    const dividerWidth = `calc(100% - ${dividerMargin}px)`;
    dividerWidthStyle = { width: dividerWidth };
  } else {
    dividerWidthStyle = { width: '100%' };
  }

  return (
    <div
      style={{
        margin: `${marginVertical}px ${marginHorizontal}px`,
        ...dividerWidthStyle,
      }}
      className="Divider"
      role="separator"
    />
  );
};

Divider.propTypes = {
  marginVertical: PropTypes.number,
  marginHorizontal: PropTypes.number,
};

Divider.defaultProps = {
  marginVertical: 10,
  marginHorizontal: 0,
};

Divider.displayName = 'Divider';
export default Divider;
